export default __webpack_public_path__ + "6b7d0bc85a2cca8f876e9045298d78c2.png";